import Vue from 'vue'
import Router from 'vue-router'
import Login from './views/login/index.vue'
import Password from './views/password/index.vue'
import resetPasswordModal from './views/login/resetPasswordModal.vue'
import MenuView from '@/layouts/MenuView.vue'
import { devError } from '@/utils/dev'
import RouteView from '@/layouts/RouteView.vue'
import Error from './views/error/index.vue'

Vue.use(Router)

/**
 * meta 类型成员，标记是否不需要登录
 */
export interface RouteMetaUnauth {
  /**
   * 标记是否不需要登录（注意不是不需要验证）
   */
  unauth: true
}

/** 标记不需要登录 */
const unauth: RouteMetaUnauth = {
  unauth: true,
}

const singleRoutes = [
  // 登录
  {
    path: '/login',
    name: 'login',
    component: Login,
    invisible: true,
    meta: unauth,
  },
  {
    path: '/resetPassword',
    name: 'resetPassword',
    component: resetPasswordModal,
    invisible: true,
    meta: unauth,
  },
  {
    path: '/password/:type/:token?',
    name: 'password',
    component: Password,
    meta: unauth,
    beforeEnter: (to: any, from: any, next: any) => {
      if (to.name == 'password' && to.params.token) {
        next()
      } else {
        next({ name: 'login' })
      }
    }
  },
]

const errorRoutes: any[] = [
  {
    path: '*',
    name: '404',
    component: Error,
    props: { code: 404 },
    meta: unauth,
  },
]

const mainLayoutRoutes: any = [
  {
    path: '/performance',
    name: '演出管理',
    component: RouteView,
    meta: {
      icon: 'calendar',
    },
    children: [
      {
        path: '/performance/list',
        name: '演出管理',
        component: () => import('./views/performance/index.vue'),
        meta: {
          icon: 'calendar',
        },
      }, {
        path: '/place/order',
        name: '下单',
        component: () => import('./views/placeorder/index.vue'),
        meta: {
          icon: 'calendar',
        },
      },
    ],
  },

  {
    path: '/order/createStepOne',
    name: '创建订单',
    component: () => import('./views/order/createOrder.vue'),
    meta: {
      icon: 'calendar',
    },
  },
  {
    path: '/order/orderEticketList',
    name: '电子票',
    component: () => import('./views/order/orderEticketList.vue'),
    meta: {
      icon: 'calendar',
    },
  },
  {
    path: '/order/orderEticketDetail',
    name: '电子票',
    component: () => import('./views/order/orderEticketDetail.vue'),
    meta: {
      icon: 'calendar',
    },
  },
  {
    path: '/order/createStepThree',
    name: '创建订单',
    component: () => import('./views/order/createOrderStep3.vue'),
    meta: {
      icon: 'calendar',
    },
  },
  {
    path: '/showtime/management',
    name: '场次管理',
    component: () => import('./views/showtimemanagement/index.vue'),
    meta: {
      icon: 'flag',
    },
  },
  {
    path: '/showtime/ticketKindDetail',
    name: '场次票种详情',
    component: () => import('./views/showtimemanagement/ticketKindDetail.vue'),
    meta: {
      icon: 'dashboard',
    },
  },
  {
    path: '/showtime/ticketKindDetail',
    name: '场次票种详情',
    component: () => import('./views/showtimemanagement/ticketKindDetail.vue'),
    meta: {
      icon: 'dashboard',
    },
  },
  {
    path: '/order/management',
    name: '订单管理',
    component: RouteView,
    meta: {
      icon: 'red-envelope'
    },
    children: [
      {
        path: '/order/retail/list',
        name: '零售订单列表',
        component: () => import('./views/ordermanagement/retail/index.vue'),
        meta: {
          icon: 'project'
        }
      },
      {
        path: '/order/group/list',
        name: '团体订单列表',
        component: () => import('./views/ordermanagement/group/index.vue'),
        meta: {
          icon: 'project'
        },
      },
    ]
  },
  {
    path: '/order/management/detail',
    name: '订单详情',
    component: () => import('./views/ordermanagement/retail/detail.vue'),
    meta: {
      show: true
    }
  },
  {
    path: '/order/management/retail/eticket',
    name: '电子票列表',
    component: () => import('./views/ordermanagement/retail/eticket.vue'),
    meta: {
      show: true
    }
  },
  {
    path: '/order/management/retail/eticket/detail',
    name: '电子票详情',
    component: () => import('./views/ordermanagement/retail/detail/eticket.vue'),
    meta: {
      show: true
    }
  },
  {
    path: '/order/management/group/eticket',
    name: '电子票列表',
    component: () => import('./views/ordermanagement/group/eticket.vue'),
    meta: {
      show: true
    }
  },
  {
    path: '/order/management/group/eticket/detail',
    name: '电子票详情',
    component: () => import('./views/ordermanagement/group/detail/eticket.vue'),
    meta: {
      show: true
    }
  },
 
]

const take403 = (list: any[]) => {
  const routesWith403 = list.map(it => {
    // 暂时不对含有 components 的组件进行操作
    if (it.components != null) {
      devError(`[config] ${it.name} has components, pass`)
      return it
    }

    const components: any = {
      default: it.component,
      403: Error,
    }

    const result: any = {
      ...it,
      components,
      props: {
        default: it.props || {},
        403: { code: 403 },
      },
    }
    delete result.component

    // 处理子级
    if (it.children && it.children.length > 0) {
      result.children = take403(it.children)
    }

    return result
  })

  return routesWith403
}

// 将「没有权限」注入到 mainLayoutRoutes 中
const mainLayoutRoutesWith403 = take403(mainLayoutRoutes)

const routes: any[] = [
  ...singleRoutes,
  {
    path: '/',
    component: MenuView,
    name: '首页',
    children: mainLayoutRoutes,
  },
  ...errorRoutes,
]

export default routes
